module.exports = __webpack_public_path__ + "logo-footer.png?5bec09377a870b491b43bc09b4eeb6dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-footer.png
// module id = 127
// module chunks = 0